import React from "react";
import "./ToPad.css";
import { useVisibilityTracker } from "../../../utils/visibilityTracker";

export function ToPad({ jsonData, objectId, showId }) {
    return (
        <div className="to-pad">
            {jsonData.map((item) => {
                const visibilityRef = useVisibilityTracker(
                    item.id,
                    objectId,
                    "ToPad",
                    jsonData.length,
                    showId,
                    item.cid,
                    item.crid,
                    item.bidder_id,
                    item.bidder_cid,
                    item.eventtrackers,
                    item
                );
                return (
                    <a key={item.id} href={item.url} target="_blank" ref={visibilityRef}>
                        <div className="to-pad-block">
                            <img src={item.img} alt={item.title} />
                            <div className="to-pad-title">
                                <h2>{item.title}</h2>
                            </div>
                        </div>
                    </a>
                );
            })}
        </div>
    );
}
